import React, { Component } from "react";
import AutoInput from "../containers/AutoInput";
import { getBelongsToValue } from "../utils/models";
import withValues from "../hocs/withValues";
import impoivaMateriales from '../utils/impoIva';
import expoivaMateriales from '../utils/expoIva';


class localCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showContent: false,
      unitprice: null,
      total: 0,
      material: null,
      materialsQuery: null,
      iva: null,
      materialEs: null,
      typeIva: null,
    };
  }

 

  render() {

    let ivaFilter = "";

    if (this.state.iva === "8%") {
      ivaFilter = this.state.unitprice * 0.08;
    }
    
    return (
      <div>
        <AutoInput
          form={this.props.form}
          model={"quote"}
          attribute={"quote"}
          value={getBelongsToValue("quote", this.props.belongsTo)}
          hidden
        />
         <AutoInput
                form={this.props.form}
                model={"local"}
                attribute={"typeIva"}
                type={'model'}
                items={['IMPORT','EXPORT']}
                onChange={value => {
                  this.setState({ typeIva: value });
                  this.props.form.resetFields('material');
                }}
              />
        <AutoInput
          form={this.props.form}
          model={"local"}
          attribute={"material"}
          placeholder={"Select Service"}
          onChange={value => {
            if(this.state.typeIva==="IMPORT"){
              const iva = impoivaMateriales.find(
                material => material.numero === value
              );
              if (iva) {
                this.setState({ iva: iva.iva });
              }
            }else if(this.state.typeIva==="EXPORT"){
              const iva = expoivaMateriales.find(
                material => material.numero === value
              );
              if (iva) {
                this.setState({ iva: iva.iva });
              }
            }
            
            this.setState({ material: value });
          }}
        />
        <AutoInput
          form={this.props.form}
          model={"local"}
          attribute={"unitprice"}
          onChange={value => {
            this.setState({ unitprice: value });
          }}
        />
        <AutoInput
          form={this.props.form}
          model={"local"}
          attribute={"iva"}
          value={this.state.iva}
          disabled
        />
        <AutoInput
          form={this.props.form}
          model={"local"}
          attribute={"total"}
          value={this.state.unitprice + ivaFilter}
          disabled
        />
      </div>
    );
  }
}

export default withValues(localCreate);



// WEBPACK FOOTER //
// ./src/forms/LocalCreate.js